// extracted by mini-css-extract-plugin
export default {"facet":"facet_group__facet--bck7","checkboxGroup":"facet_group__checkboxGroup--+FoQ","checkboxText":"facet_group__checkboxText--lDgh"};